import React, { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import { Select } from "antd";
import {
  SocketTopics,
  UserTopics,
  ExtendedBioTopics,
} from "../../constants/enums";
import {
  getVehicleTypesPath
} from "../../hooks/socketConstants";
import useSocketActions from "../../hooks/socketActions";
import { useLocation } from "react-router-dom";
import { getVehicleTypesTopic, getVehiclesPublishTopic, getVehiclesSubscriptionTopic } from "hooks/MQTTConstants";
import { wrapRequestPayload } from "../../helpers/request/RequestPayload";

const { Option } = Select;

const VehicleInput = (props: any) => {
  const { value, placeholder, onChange, socket, vehicleType } = props;
  const { projects, users_filter, encrypted_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { search } = useLocation();

  const defaultPagination = 50;
  const [page, setPage] = useState(0);
  const [searching, setSearching] = useState(false);
  const [pagination, setPagination] = useState(true);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const { getUserRequestPayload } = useSocketActions();

  let timeout;

  const getVehicles = () => {
    // const query = new URLSearchParams(search);
    // const connectionId = query.get("connectionId");
    // const userId = query.get("userId");
    setSearching(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getVehiclesPublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({userId: encrypted_token?.userId})
    );
  }
  useEffect(() => {
    if (projects?.userServiceId) {
      // const query = new URLSearchParams(search);
      // const connectionId = query.get("connectionId");
      // console.log("get vehicle types");

      // socket.publishToEvent(
      //   SocketTopics.PublishPageTopics,
      //   getVehiclesPublishTopic(connectionId),
      //   wrapRequestPayload({userId})
      // );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getVehiclesSubscriptionTopic(encrypted_token?.connectionId),
        (response) => {
          console.log("vehicles", response?.response?.data?.projects);
          setSearching(false);
          const opts = response?.response?.data?.projects
            ?.map((x) => {
              return {
                id: x.assosiatedUserId,
                name: x.name,
                obj: x,
              };
            })
            .filter((x) => {
              return x.id !== undefined
            });
          setOptions([...options, ...opts]);
        }
      );
    }
  }, [projects?.userServiceId]);

  useEffect(()=>{
    console.log('vehicle type', vehicleType)
  }, [vehicleType])

  // useEffect(() => {
  //   if (users_filter) {
  //     setSearching(false);
  // const opts = users_filter
  //   ?.map((x) => {
  //     return {
  //       id: x.id,
  //       name: x.name,
  //       obj: x,
  //     };
  //   })
  //   .filter((x) => {
  //     return !options.find((y) => {
  //       return x.id === y.id;
  //     });
  //   });
  // setOptions([...options, ...opts]);
  //     if (opts.length === 0) {
  //       setPagination(false);
  //     }
  //   }
  // }, [users_filter]);

  return (
    <Select
      showSearch
      // mode={"multiple"}
      className="w-full"
      value={value?.value}
      allowClear={true}
      placeholder={placeholder}
      // disabled={adminRoles === undefined}
      onChange={(value) => {
        // const changes = [];
        // values.map((value) => {
        //   const responder = options.find((x) => {
        //     return x.id === value;
        //   });
        //   changes.push({
        //     id: value,
        //     ...responder.obj,
        //   });
        // });
        const type = options.find((x) => {
          return x.id === value;
        });
        onChange({
          type: "vehicle",
          // responders: changes,
          value,
          obj: type
        });
      }}
      loading={searching}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onFocus={() => {
        // if ((users_filter?.length ?? 0) === 0) getUsers(0);
        if (projects?.userServiceId) {
          getVehicles();
        }
      }}
      onSearch={(search) => {
        // if (timeout) clearTimeout(timeout);
        // timeout = setTimeout(() => {
        //   if (search && search !== "") {
        //     getUsers(0, search);
        //     setPagination(false);
        //   } else getUsers(0);
        // }, 500);
      }}
      onPopupScroll={(e: any) => {
        // e.persist();
        // let target = e.target;
        // if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        //   if (pagination) {
        //     getUsers(page + 1);
        //   }
        // }
      }}
    >
      {options?.filter((x)=>{
        return vehicleType === undefined || vehicleType === x?.obj?.typeId
      })?.map((option, index) => (
        <Option key={index} value={option.id}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};

export default VehicleInput;
